var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  className: "svg-safari-fix",
  viewBox: "0 0 24 24",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM15.8349 9.55053C16.1389 9.08943 16.0115 8.46921 15.5504 8.16522C15.0893 7.86123 14.4691 7.9886 14.1651 8.44969L10.9512 13.3246L9.70711 12.0805C9.31658 11.69 8.68342 11.69 8.29289 12.0805C7.90237 12.471 7.90237 13.1042 8.29289 13.4947L10.4041 15.6059C10.6166 15.8184 10.9133 15.924 11.2123 15.8937C11.5112 15.8633 11.7807 15.7001 11.9461 15.4492L15.8349 9.55053Z",
  fill: "inherit"
})));
export default SvgCheck;